export const pressQuotes = [
  {
    publication: "Relix",
    quote:
      "Against a stunning backdrop of nightfall on the Rio Grande River in Del Norte, Colo., Donato and his tried-and-true backing ensemble delivered two sprawling sets that pored over his catalog.",
    headline:
      "Daniel Donato's Cosmic Country Welcome Billy Failing at Rhythms on the Rio",
    href: "https://relix.com/news/detail/daniel-donatos-cosmic-country-welcome-billy-failing-at-rhythms-on-the-rio/",
  },
  {
    publication: "Westword",
    quote:
      "Family-friendly event that combines outdoor rec with quality live music and is entirely volunteer-run.",
    headline: "The Best Music Festivals in Colorado This Summer",
    href: "https://www.westword.com/music/best-colorado-summer-music-festivals-16619945",
  },
  {
    publication: "5280",
    quote:
      "Stirs the spirit of the '60s — an aura that radiates to its campsite communes along the banks.",
    headline: "4 Can't-Miss Colorado Camping Music Fests",
    href: "https://www.5280.com/colorado-camping-music-fests/#rhythms-on-the-rio",
  },
  {
    publication: "Festy GoNuts",
    quote:
      "A music festival can morph into something more than the sum of its parts, reverberating throughout the outer stretches of the ether, touching all edges of the cosmos with its energy.",
    headline:
      "Rhythms on the Rio 2024 Review: Magic, Family, and the Epitome of Festival",
    href: "https://www.festygonuts.com/rhythms-on-the-rio-2024-review/",
  },
  {
    publication: "Pagosa Daily Post",
    quote:
      "The festival reminds us of all the reasons why we truly love music — the random connections, new and old friends coming together, and those moments mid-song that make you think, 'Wow, how beautiful.'",
    headline: "Rhythms on the Rio 2024: Why We Love Music",
    href: "https://pagosadailypost.com/2024/08/12/rhythms-on-the-rio-2024-why-we-love-music/",
  },
  {
    publication: "Grateful Web",
    quote:
      "Festivalgoers will gather along the scenic banks of the Rio Grande in Del Norte, Colorado, for a weekend filled with stellar performances, outdoor adventures, and community spirit.",
    headline:
      "2025 Rhythms on the Rio Set to Deliver Unforgettable Summer Experience",
    href: "https://www.gratefulweb.com/articles/2025-rhythms-rio-set-deliver-unforgettable-summer-experience-colorados-scenic-del-norte",
  },
  {
    publication: "Alamosa Citizen",
    quote: "Eclectic lineup promises 'a little bit of everything.'",
    headline: "Rhythms on the Rio returns to Del Norte",
    href: "https://www.alamosacitizen.com/rhythms-on-the-rio-returns-to-del-norte/",
  },
  {
    publication: "Music Festival Wizard",
    quote: "",
    headline: "Rhythms on the Rio 2026",
    href: "https://www.musicfestivalwizard.com/festivals/rhythms-on-the-rio-2026/",
  },
];
